import React from "react";
import { Star } from "lucide-react";

interface CandidateProfileSummaryProps {
  candidate: {
    name: string;
    score: string;
    ratings: number;
    experience: number;
    date: string;
    source: string;
    candidateid?: string;
    id?: string;
  };
}

const CandidateProfileSummary: React.FC<CandidateProfileSummaryProps> = ({
  candidate,
}) => {
  return (
    <div className="bg-white border rounded-lg shadow-sm p-5 mb-6">
      <div className="flex items-center mb-4">
        <div className="h-16 w-16 rounded-full bg-neutral-200 flex items-center justify-center text-xl font-medium text-neutral-600 mr-4">
          {candidate.name.charAt(0)}
        </div>
        <div>
          <h3 className="text-lg font-semibold">{candidate.name}</h3>
          <div className="flex items-center gap-3 mt-1">
            <span
              className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                parseInt(candidate.score) >= 90
                  ? "bg-green-100 text-green-800"
                  : parseInt(candidate.score) >= 70
                    ? "bg-yellow-100 text-yellow-800"
                    : "bg-red-100 text-red-800"
              }`}
            >
              Score: {candidate.score}
            </span>
            <div className="flex items-center">
              {Array.from({ length: Math.min(candidate.ratings, 5) }).map(
                (_, i) => (
                  <Star
                    key={i}
                    className="h-3 w-3 text-yellow-400 fill-current"
                  />
                )
              )}
              {candidate.ratings > 5 && (
                <span className="text-xs ml-1">+{candidate.ratings - 5}</span>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-3 text-sm">
        <div className="flex flex-col bg-neutral-50 rounded-md px-3 py-2">
          <span className="text-neutral-500 text-xs">Experience</span>
          <span className="font-medium">{candidate.experience} years</span>
        </div>
        <div className="flex flex-col bg-neutral-50 rounded-md px-3 py-2">
          <span className="text-neutral-500 text-xs">Applied On</span>
          <span className="font-medium">
            {new Date(candidate.date).toLocaleDateString()}
          </span>
        </div>
        <div className="flex flex-col bg-neutral-50 rounded-md px-3 py-2">
          <span className="text-neutral-500 text-xs">Source</span>
          <span className="font-medium">{candidate.source}</span>
        </div>
        {candidate.candidateid && (
          <div className="flex flex-col bg-neutral-50 rounded-md px-3 py-2 col-span-3">
            <span className="text-neutral-500 text-xs">Candidate ID</span>
            <span className="font-medium">{candidate.candidateid}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(CandidateProfileSummary);
